import React from 'react'
import MediaQuery from 'react-responsive'
import theme from '../../styles/theme'

const Mobile = ({ children }) => {
  return <MediaQuery query={`(${theme.mq.mobile})`}>{children}</MediaQuery>
}

const Desktop = ({ children }) => {
  return <MediaQuery query={`(${theme.mq.desktop})`}>{children}</MediaQuery>
}

export { Mobile, Desktop }
